var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonusFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.25h4.175L9.295 3H5.616a1 1 0 00-.857.486L2.5 7.25zM2.627 8.75l8.63 11.22a.938.938 0 00.043.051V8.75H2.627zM12.8 20.021c.015-.016.029-.034.043-.051l8.63-11.22H12.8v11.271zM21.6 7.25l-2.259-3.764A1 1 0 0018.484 3h-3.68l2.621 4.25H21.6zM13.05 3h-2l-2.5 4.25h7L13.05 3z",
    fill: "currentColor"
  })));
}
SvgBonusFilled.displayName = 'BonusFilled';
export default SvgBonusFilled;